<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  watch: {
    '$route'(to) {
      // Add class to body for landing page to isolate styles
      if (to.path === '/') {
        document.body.classList.add('is-landing-page')
        document.body.classList.remove('has-sidebar')
      } else {
        document.body.classList.remove('is-landing-page')
      }
    }
  },
  mounted() {
    // Check initial route
    if (this.$route.path === '/') {
      document.body.classList.add('is-landing-page')
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';

  // Reset all CoreUI styles for landing page
  body.is-landing-page {
    margin: 0 !important;
    padding: 0 !important;
    background: #0d1117 !important;
    font-family: 'Barlow', 'Inter', sans-serif !important;

    // Hide CoreUI elements on landing page
    .sidebar,
    .header,
    .c-sidebar,
    .c-header {
      display: none !important;
    }
  }
</style>
